export default "__VITE_ASSET__BImQZQc$__"